import { useAuth } from '@sal/authentication.react';

export interface PermissionRequirement {
	securityContext: string;
	permission: string | string[];
}

export function useHasPermissions(
	requirements: PermissionRequirement[],
): boolean {
	const { userHasPermission } = useAuth();

	return requirements.every(({ securityContext, permission }) =>
		userHasPermission(securityContext, permission),
	);
}
